import {
  ErrorView,
  PageLayout,
  PageNames,
  ThingContent,
  useEntityPageStore,
  useThingContent,
  useWorkPageStore,
} from '@diana/core';
import { useParams } from 'react-router-dom';
import { useWorkPageRightDrawerProps } from '../WorkPage/useWorkPageDrawerProps';
import { Header } from './Header';
import { useThingPageLeftDrawerProps } from './useThingPageDrawerProps';

export const ThingPage = ({ peoplePage = false }: { peoplePage?: boolean }) => {
  const { thingId } = useParams<{ thingId: string }>();
  const { userId } = useParams<{ userId: string }>();
  const assetId = peoplePage ? userId : thingId;

  const entity = useEntityPageStore((store) => store.entity);
  const flow = useEntityPageStore((store) => store.flow);
  const work = useWorkPageStore((store) => store.work);

  const { isLoading, isEditing, draftWorkId, EditButton, showError, error } = useThingContent({
    thingId: assetId ?? '',
    peoplePage,
  });

  const leftDrawerProps = useThingPageLeftDrawerProps({
    thing: isEditing ? work : entity,
    isLoading,
    flow,
    peoplePage,
  });

  const rightDrawerProps = useWorkPageRightDrawerProps({ work: entity, isLoading });

  const drawerProps = !showError
    ? { leftDrawer: leftDrawerProps, rightDrawer: rightDrawerProps }
    : undefined;

  return (
    <PageLayout
      name={peoplePage ? PageNames.USER : PageNames.THING}
      title={entity ? `${entity?.displayName}` : undefined}
      headerWithBorder={!showError}
      {...drawerProps}
      header={<Header entityId={assetId!} entity={entity} peoplePage={peoplePage} />}
    >
      {showError ? (
        <ErrorView responseError={error} />
      ) : (
        <ThingContent
          draftWorkId={draftWorkId}
          isLoading={isLoading}
          isEditing={isEditing}
          EditButton={EditButton}
          peoplePage={peoplePage}
        />
      )}
    </PageLayout>
  );
};
